import React, { useRef, useState } from 'react';
import './App.css';
import { AiOutlineSend} from "react-icons/ai";
import {  FaCodiepie  } from "react-icons/fa";
//import firebase from 'firebase/app'; ]
//older version
import firebase from 'firebase/compat/app'; //v9
//to use auth
//import 'firebase/auth'; //older version
import 'firebase/compat/auth'; //v9
//to use firestore
//import 'firebase/firestore'; //Older Version
import 'firebase/compat/firestore'; //v9
import 'firebase/analytics';

import { useAuthState } from 'react-firebase-hooks/auth';
import { useCollectionData } from 'react-firebase-hooks/firestore';

firebase.initializeApp({
  // your config
  apiKey: "AIzaSyC24rR-lCBwLchtAxL0rsMS7YJZW4upUu0",
  authDomain: "react-chat-app-eaa44.firebaseapp.com",
  projectId: "react-chat-app-eaa44",
  databaseURL: "https:/react-chat-app-eaa44.firebaseio.com",
  storageBucket: "react-chat-app-eaa44.appspot.com",
  messagingSenderId: "496036355940",
  appId: "1:496036355940:web:95a8a5a19541843bf6e471",
  measurementId: "G-96FBHLVDPH"
})
const auth = firebase.auth();
const firestore = firebase.firestore();
function App() {

  const [user] = useAuthState(auth);

  return (
    <div className="App">
      <header>
        <h1><FaCodiepie/></h1>
        <SignOut />
      </header>
      <section className='w-100 text-center'>
        {user ? <ChatRoom /> : <SignIn />}
      </section>
    </div>
  );
}
function SignIn() {
  const signInWithGoogle = () => {
    const provider = new firebase.auth.GoogleAuthProvider();
    auth.signInWithPopup(provider);
}
  return (
    <>
      <div className="container ">
        <div className="row pt-3 w-100">
          <div className="col-md-4">
          <img className="img1 img-fluid" src={require('./Frame.png')} alt="person images" />
          </div>
          <div className="col-md-4">
            <h1 style={{ color: "white",margin:"40px" }}>Group Chat <br/><b>For EveryOne</b></h1>
            <button className="sign-in btn rounded-0" onClick={signInWithGoogle}>Sign in with Google</button>
            <p style={{ textAlign: "center" }}>Do not violate the community guidelines or you will be banned for life!</p>
          </div>
          <div className="col-md-4">
          <img className="img2 img-fluid" src={require('./Frame.png')} alt="person images"/>
          </div>
        </div>
      </div>
    </>
  )
}
function SignOut() {
  return auth.currentUser && (
    <button className="sign-out" onClick={() => auth.signOut()}>Sign Out</button>
  )
}


function ChatRoom() {
  const dummy = useRef();
  const messagesRef = firestore.collection('messages');
  const query = messagesRef.orderBy('createdAt').limit(25);

  const [messages] = useCollectionData(query, { idField: 'id' });

  const [formValue, setFormValue] = useState('');


  const sendMessage = async (e) => {
    e.preventDefault();

    const { uid, photoURL } = auth.currentUser;

    await messagesRef.add({
      text: formValue,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      uid,
      photoURL
    })

    setFormValue('');
    dummy.current.scrollIntoView({ behavior: 'smooth' });
  }
  return (<>
  
    <main>

      {messages && messages.map(msg => <ChatMessage key={msg.id} message={msg} />)}

      <span ref={dummy}></span>

    </main>
    <form onSubmit={sendMessage} >
      <input className="input-lg" style={{width:"97.3vw"}} value={formValue} onChange={(e) => setFormValue(e.target.value)} placeholder="say something nice" />
      <button type="submit" disabled={!formValue}><AiOutlineSend/></button>
    </form>
  </>
  )
}


function ChatMessage(props) {
  const { text, uid, photoURL } = props.message;

  const messageClass = uid === auth.currentUser.uid ? 'sent' : 'received';

  return (<>
    <div className={`message ${messageClass}`}>
    <img  src={photoURL} style={{borderRadius:"50%",width:"24px",height:"24px"}} alt="person"/>
      <p>{text}</p>
    </div>
  </>
  )
}


export default App;